import React from 'react'
import CollegeFootball from 'src/components/page/college-football'
import { teamIds } from 'src/constants/personalizationIds'

export default (props) => (
  <CollegeFootball {...props} team="Ole Miss Rebels" teamId={teamIds['Ole Miss Rebels']} />
)
